import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject } from "aurelia-dependency-injection";
import { SubscriptionHelper } from '../../helpers/subscription-helper';

@autoinject
export class UpgradeSubscriptionDialog {
    content: string;
    productCode: string;

    constructor(private dialogClientService: DialogClientService, private subscriptionHelper: SubscriptionHelper) {
        
    }

    activate(model: { content: string, productCode: string }) {
        this.content = model.content;
        this.productCode = model.productCode;
    }

    cancel() {
        this.dialogClientService.hide();
    }

    upgradeSubscription() {
        const url: string = this.subscriptionHelper.getUpgradeSubscriptionUrl(this.productCode);
        window.open(url, "_blank");
    }
}